import { instanceOEF, segundaVersaoOEF } from './api'

export const postSegundaAssinaturaAPI = dadosSegundaAssinatura => {
  return instanceOEF.post( `${segundaVersaoOEF}/assinatura/`, dadosSegundaAssinatura )
}
